"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));
var _react = _interopRequireDefault(require("react"));
var _styled = _interopRequireWildcard(require("../styled"));
var _excluded = ["duration", "color", "size"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var bubbleAnimation = (0, _styled.keyframes)(_templateObject || (_templateObject = (0, _taggedTemplateLiteralLoose2.default)(["\n  0%, 80%, 100% {\n    transform: scale(0.9);\n  }\n  50% {\n    transform: scale(0.4);\n  }\n"])));
var sizeStyle = function sizeStyle(props) {
  switch (props.size) {
    case 'small':
      return '0.25em';
    case 'large':
      return '1.25em';
    default:
      return '0.75em';
  }
};
var BubbleWrapper = _styled.default.div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteralLoose2.default)(["\n  margin: 0 auto;\n  width: 7.5em;\n  height: 2.5em;\n  text-align: center;\n  font-size: ", ";\n  color: ", ";\n  opacity: 0.7;  \n  ", "\n"])), sizeStyle, (0, _styled.prop)('color'), (0, _styled.ifProp)('center', (0, _styled.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteralLoose2.default)(["\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  "])))));
var Bubble1 = _styled.default.div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteralLoose2.default)(["\n  animation: ", ";\n  animation-delay: ", ";\n  width: 2.5em;\n  height: 2.5em;\n  background-color: currentColor;\n  border-radius: 50%;\n  display: inline-block;\n"])), function (props) {
  return (0, _styled.css)(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteralLoose2.default)(["\n      ", "s ", " ease-in-out infinite both\n    "])), props.duration, bubbleAnimation);
}, function (props) {
  return props.duration * -0.32 + "s";
});
var Bubble2 = (0, _styled.default)(Bubble1)(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteralLoose2.default)(["\n  animation-delay: ", ";\n"])), function (props) {
  return (0, _styled.css)(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteralLoose2.default)(["\n      ", "s\n    "])), props.duration * -0.16);
});
var Bubble3 = (0, _styled.default)(Bubble1)(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteralLoose2.default)(["\n  animation-delay: 0s;\n"])));
var BubbleLoader = function BubbleLoader(_ref) {
  var duration = _ref.duration,
    color = _ref.color,
    size = _ref.size,
    rest = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(BubbleWrapper, Object.assign({
    color: color,
    size: size
  }, rest), /*#__PURE__*/_react.default.createElement(Bubble1, {
    duration: duration
  }), /*#__PURE__*/_react.default.createElement(Bubble2, {
    duration: duration
  }), /*#__PURE__*/_react.default.createElement(Bubble3, {
    duration: duration
  }));
};
BubbleLoader.defaultProps = {
  duration: 0.7,
  color: '#000',
  size: null
};
var _default = exports.default = BubbleLoader;